export default "__VITE_ASSET__C_ZHSn1i__"